import React from 'react';

import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { Storage } from 'aws-amplify';

import { AWS_CONFIG } from '../../../../common/components/tfa-auth/config/config';

type Props = {
  filename: string;
  userId: number;
};

const AdminScanThumbnail: React.FC<Props> = ({ filename, userId }) => {
  const [imageUrl, setImageUrl] = React.useState('');
  const [seed, setSeed] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const reset = () => {
    setSeed(Math.random());
  };

  const getImageUrl = () => {
    try {
      if (!userId) return '';
      const result = /[^/]*$/.exec(filename)?.[0].split('.')[0];
      if (!result) return;
      Storage.get(`${userId}/${result}.png`, {
        level: 'public',
        bucket: AWS_CONFIG.Storage.bucket,
        region: 'us-east-1',
      }).then((url) => {
        setImageUrl(url);
      });
    } catch (error: any) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    setLoaded(false);
    getImageUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filename]);

  const downloadPdf = () => {
    if (!userId) return;
    if (!loaded) return;
    const bucketUrl = process.env.REACT_APP_AWS_PDF_BUCKET ?? '';
    const result = /[^/]*$/.exec(filename)?.[0].split('.')[0];
    if (!result) return;
    const fileUrl = `${userId}/${result}.pdf`;
    Storage.get(fileUrl, {
      level: 'public',
      bucket: bucketUrl,
      region: 'us-east-1',
    }).then((url) => {
      window.open(url, '_blank');
    });
  };

  return (
    <>
      {!loaded && (
        <Box
          style={{ display: 'flex', justifyContent: 'center', paddingTop: 24 }}
        >
          <CircularProgress color='primary' size='32px' />
        </Box>
      )}
      <Box
        onClick={downloadPdf}
        key={seed}
        component='img'
        src={imageUrl}
        onError={() => {
          setTimeout(() => reset(), 350);
        }}
        onLoad={() => setLoaded(true)}
        sx={{
          objectFit: 'cover',
          width: '116px',
          height: '148px',
          borderRadius: '16px',
          visibility: loaded ? 'visible' : 'hidden',
        }}
      />
    </>
  );
};

export default AdminScanThumbnail;
